import { cva } from 'cva'

export const tabListStyle = cva({
  base: [
    // 레이아웃
    'inline-flex',
    'items-center',
    'justify-center',
    'w-full',
  ],

  variants: {
    variants: {
      flexible: ['border-b', 'border-b-gray-200', 'justify-between'],
      static: ['border-b', 'border-b-gray-200', 'justify-start px-5 gap-5'],
      sub: ['justify-start gap-2'],
    },
  },

  defaultVariants: {
    variants: 'flexible',
  },
})

export const tabsTriggerStyle = cva({
  base: [
    // 레이아웃
    'inline-flex',
    'items-center',
    'justify-center',
    'whitespace-nowrap',

    // 패딩 & 크기
    'text-sm',
    'py-3.5',

    // 스타일링
    'font-bold',
    'text-xl',
    'ring-offset-background',
    'transition-all',
    'border-b-gray-200',
    'text-gray-400',

    // 포커스
    'focus-visible:outline-none',
    'focus-visible:ring-2',
    'focus-visible:ring-ring',
    'focus-visible:ring-offset-2',

    // 비활성화 상태
    'disabled:pointer-events-none',
    'disabled:opacity-50',
  ],

  variants: {
    variants: {
      static: [
        // 비활성화 상태
        'disabled:pointer-events-none',
        'disabled:opacity-50',

        // 활성화 상태
        'data-[state=active]:text-gray-900',
        'data-[state=active]:border-b-2',
        'data-[state=active]:border-b-gray-900',
      ],
      flexible: [
        'flex-1',

        // 비활성화 상태
        'disabled:pointer-events-none',
        'disabled:opacity-50',

        // 활성화 상태
        'data-[state=active]:text-gray-900',
        'data-[state=active]:border-b-2',
        'data-[state=active]:border-b-gray-900',
      ],
      sub: [
        // 레이아웃
        'px-3 py-[5px] border rounded-full whitespace-nowrap transition-colors',

        'text-sm',
        'text-gray-900',
        // 활성화 상태
        'data-[state=active]:bg-green-100',
        'data-[state=active]:border-primary',
      ],
    },
  },

  defaultVariants: {
    variants: 'flexible',
  },
})

// V1 styles for backwards compatibility
export const tabListV1Style = cva({
  base: ['inline-flex', 'items-center', 'justify-center', 'w-full', 'border-b', 'border-b-gray-200'],

  variants: {
    variants: {
      static: ['justify-start px-5 gap-5'],
      flexible: ['justify-between'],
    },
  },

  defaultVariants: {
    variants: 'flexible',
  },
})

export const tabsTriggerV1Style = cva({
  base: [
    'inline-flex',
    'items-center',
    'justify-center',
    'whitespace-nowrap',
    'text-sm',
    'py-3.5',
    'font-bold',
    'text-[16px]',
    'ring-offset-background',
    'transition-all',
    'border-b-gray-200',
    'text-gray-400',
    'focus-visible:outline-none',
    'focus-visible:ring-2',
    'focus-visible:ring-ring',
    'focus-visible:ring-offset-2',
    'disabled:pointer-events-none',
    'disabled:opacity-50',
    'data-[state=active]:text-gray-900',
    'data-[state=active]:border-b-2',
    'data-[state=active]:border-b-gray-900',
  ],

  variants: {
    variants: {
      static: [],
      flexible: ['flex-1'],
    },
  },

  defaultVariants: {
    variants: 'flexible',
  },
})
